import { TooltipDesignTokens } from '@primeng/themes/types/tooltip';

export const baseTooltipToken: TooltipDesignTokens = {
  root: {
    gutter: '0',
    padding: '0.1875rem 0.375rem',
    borderRadius: '0.25rem',
  },
  colorScheme: {
    light: {
      root: {
        background: '{other.opacity.black.70}',
        color: '{surface.0}',
      },
    },
  },
  css: ({ dt }: { dt: (token: string, val?: string) => string }) => `
    .p-tooltip {
      margin-top: 0.25rem;
      border-radius: ${dt('tooltip.root.borderRadius')};
      box-shadow: 0px 2px 4px 0px #00000026;
      backdrop-filter: blur(0.5rem);
      -webkit-backdrop-filter: blur(0.5rem);
    }

    .p-tooltip-arrow {
      display: none;
    }

    .p-tooltip-text {
      font-weight: 500;
      font-size: 0.6875rem;
      line-height: 150%;
    }
    `,
};
